export const APPRAISER_HIGHLIGHTS_CONTENT_FILE_PATH = '/editorial/includes/appraisals/highlights';
